module.exports = __webpack_public_path__ + "img/not-found-image.80495b2f.jpg";